import { SessionsAPI } from "../../session";

type ListPatientSessionsParams = Parameters<typeof SessionsAPI.list_by_patient>[1];

/** The sessions of the patient or couple a plan belongs to, which its phases can link. */
export async function listPlanSubjectSessions(
  subjectId: string,
  isCouple: boolean | undefined,
  params: ListPatientSessionsParams
) {
  const { data } = await (isCouple
    ? SessionsAPI.list_by_couple_patient(subjectId, params)
    : SessionsAPI.list_by_patient(subjectId, params));
  return data.sessions;
}
